module.exports = __webpack_public_path__ + "img/NOI_THAT.14937eb9.svg";